import { mapActions, mapGetters } from 'vuex'
import PageName  from '@/views/backstage/constants/PageName'
import { Message } from 'element-ui';

// 頁面/功能名稱
const RESOURCE_DASHBOARD_ISSUE_REPORT = '功能-首頁/問題回報'
const RESOURCE_DETAIL = '功能-單筆資料詳目頁'
const RESOURCE_DIGITAL_RESOURCE_MANAGEMENT = '功能-數位資源管理'
const RESOURCE_DIGITAL_OBJECT_MANAGEMENT = '功能-數位資源管理/數位物件'
const RESOURCE_FILE_TYPE_MANAGEMENT = '功能-檔案類別管理'
const RESOURCE_ACCOUNT_MANAGEMENT = '功能-系統管理/帳號'
const RESOURCE_SYSTEM_LOG = '功能-系統管理/系統日誌'
const RESOURCE_ISSUE_REPORT_MANAGEMENT = '功能-系統管理/問題回報管理'
const RESOURCE_MY_ISSUE_REPORT = '功能-系統管理/我的問題回報'
const RESOURCE_SYNONYM_MANAGEMENT = '功能-系統管理/同義辭彙設定'
const RESOURCE_REVIEW = '功能-審核專區'
const RESOURCE_FRONT_STAGE_DATA = '功能-前臺開放資料'

// 角色列表
const ROLE_SYSTEM_SUPER_ADMIN = '最高管理者'
const ROLE_SYSTEM_ADMIN = '系統管理者'
const ROLE_ORDINARY_USER = '一般使用者'
const ROLE_DATA_INPUT = '資料輸入人員'

// 存取動作
const VIEW = '進入頁面'
const GET = '檢視'
const LIST = '列表'
const ADD = '登錄'
const EDIT = '編輯'
const SUSPEND = '凍結帳號'
const RESUME = '復原帳號'
const DELETE = '刪除'
const REVIEW = '審核/上架/下架'
const ASSIGN_DEPUTY = '指定代理人'
const EXPORT = '匯出'
const IMPORT = '匯入'
const CHANGE_PASSWORD = '更改密碼'


// 檢查失敗時的動作
const REJECT_REDIRECT = '重新導向至'

// 細部控制
const check_access = (acl, access) => {
    if (acl.indexOf(access['name']) !== -1) {
        return true
    }
    return false
}

const check_self = ({resource_info, account_info}) => {
    return resource_info['context']['creator_id'] === account_info['id'] || resource_info['context']['owner_id'] === account_info['id']
}

const check_not_self = ({resource_info, account_info}) => {
    if (resource_info['owner_identifier']) {
        return resource_info['context'][resource_info['owner_identifier']] !== account_info['id']
    }

    return false
}

const map_role_level = (role) => {
    switch(role) {
        case '最高管理者': return 4
        case '系統管理者': return 3
        case '資料輸入人員': return 2
        case '一般使用者': return 1
        default: 
            debugger
            Message.error({message: `未知的使用者角色: ${role}`})
            return 0
    }
}

const compare_role = (role_a, role_b) => {
    if (map_role_level(role_a) >= map_role_level(role_b)) {
        return true
    }
    return false
}

const check_lower_level = ({resource_info, account_info}) => {
    if (compare_role(account_info['roles'][0]['role_name'], resource_info['context']['roles'])) {
        return true
    }
    return false
}

const check_agent = ({account_info}) => {
    return account_info['agent'] === true
}

const POLICY = {}
POLICY[ROLE_SYSTEM_SUPER_ADMIN] = {}
POLICY[ROLE_DATA_INPUT] = {}
POLICY[ROLE_ORDINARY_USER] = {}

// 最高管理者
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_DASHBOARD] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_INTEGREATED_SERACH] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_GROUP_FILE_TYPE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_RECORDGROUP_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_SUB_RECORDGROUP_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_FOLDER_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_GROUP_SYSTEM_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_ACCOUNT_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_SYSTEM_LOG] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_SYNONYM_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_ISSUE_REPORT_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_MY_ISSUE_REPORT] = false
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_GROUP_REVIEW_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_REVIEW] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_FRONT_STAGE_DATA] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_GROUP_FRONT_STAGE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_THEME_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_LATEST_NEWS_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT] = true

POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_DASHBOARD_ISSUE_REPORT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_DETAIL] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_DIGITAL_RESOURCE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_DIGITAL_OBJECT_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_FILE_TYPE_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_ACCOUNT_MANAGEMENT] = ({resource_info, account_info, access}) =>  {
    if (access && [DELETE, SUSPEND, RESUME].indexOf(access['name']) !== -1 && !check_not_self({resource_info, account_info})) {
        return false
    }
    return check_lower_level({resource_info, account_info})
}
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_SYSTEM_LOG] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_ISSUE_REPORT_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_MY_ISSUE_REPORT] = false
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_SYNONYM_MANAGEMENT] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_REVIEW] = true
POLICY[ROLE_SYSTEM_SUPER_ADMIN][RESOURCE_FRONT_STAGE_DATA] = true

// 系統管理者
POLICY[ROLE_SYSTEM_ADMIN] = Object.assign({}, POLICY[ROLE_SYSTEM_SUPER_ADMIN])
POLICY[ROLE_SYSTEM_ADMIN][RESOURCE_REVIEW] = false
POLICY[ROLE_SYSTEM_ADMIN][RESOURCE_FRONT_STAGE_DATA] = false
POLICY[ROLE_SYSTEM_ADMIN][PageName.PAGE_GROUP_REVIEW_MANAGEMENT] = check_agent
POLICY[ROLE_SYSTEM_ADMIN][PageName.PAGE_REVIEW] = true
POLICY[ROLE_SYSTEM_ADMIN][PageName.PAGE_FRONT_STAGE_DATA] = check_agent
POLICY[ROLE_SYSTEM_ADMIN][RESOURCE_REVIEW] = ({resource_info, account_info, access}) => check_agent({account_info}) && check_access([VIEW], access)

// 資料處理人員
POLICY[ROLE_DATA_INPUT][PageName.PAGE_DASHBOARD] = true
POLICY[ROLE_DATA_INPUT][PageName.PAGE_INTEGREATED_SERACH] = true
POLICY[ROLE_DATA_INPUT][PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT] = true
POLICY[ROLE_DATA_INPUT][PageName.PAGE_GROUP_FILE_TYPE_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_RECORDGROUP_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_SUB_RECORDGROUP_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_FOLDER_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_GROUP_SYSTEM_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_ACCOUNT_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_SYSTEM_LOG] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_SYNONYM_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_ISSUE_REPORT_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_MY_ISSUE_REPORT] = true
POLICY[ROLE_DATA_INPUT][PageName.PAGE_GROUP_REVIEW_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_REVIEW] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_FRONT_STAGE_DATA] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_GROUP_FRONT_STAGE_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_THEME_MANAGEMENT] = false

POLICY[ROLE_DATA_INPUT][RESOURCE_DASHBOARD_ISSUE_REPORT] = true
POLICY[ROLE_DATA_INPUT][RESOURCE_DETAIL] = ({access}) => check_access([LIST, GET, ADD, EDIT], access)
POLICY[ROLE_DATA_INPUT][RESOURCE_DIGITAL_RESOURCE_MANAGEMENT] = ({access}) => check_access([LIST, GET, ADD, EDIT], access)
POLICY[ROLE_DATA_INPUT][RESOURCE_DIGITAL_OBJECT_MANAGEMENT] = ({access}) => check_access([LIST, GET, ADD, EDIT], access)
POLICY[ROLE_DATA_INPUT][RESOURCE_FILE_TYPE_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][RESOURCE_ACCOUNT_MANAGEMENT] = ({resource_info, account_info, access}) => check_access([GET, EDIT], access) && check_self({resource_info, account_info})
POLICY[ROLE_DATA_INPUT][RESOURCE_SYSTEM_LOG] = false
POLICY[ROLE_DATA_INPUT][RESOURCE_ISSUE_REPORT_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][RESOURCE_MY_ISSUE_REPORT] = true
POLICY[ROLE_DATA_INPUT][RESOURCE_SYNONYM_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][RESOURCE_REVIEW] = false
POLICY[ROLE_DATA_INPUT][RESOURCE_FRONT_STAGE_DATA] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_GROUP_FRONT_STAGE_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_THEME_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_LATEST_NEWS_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT] = false
POLICY[ROLE_DATA_INPUT][PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT] = false

// 一般使用者
POLICY[ROLE_ORDINARY_USER] = Object.assign({}, POLICY[ROLE_DATA_INPUT])
POLICY[ROLE_ORDINARY_USER][RESOURCE_DETAIL] = ({access}) => check_access([LIST, GET], access)
POLICY[ROLE_ORDINARY_USER][RESOURCE_DIGITAL_RESOURCE_MANAGEMENT] = ({access}) => check_access([LIST, GET], access)
POLICY[ROLE_ORDINARY_USER][RESOURCE_DIGITAL_OBJECT_MANAGEMENT] = false
POLICY[ROLE_ORDINARY_USER][PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT] = false

export default {

    computed: {
        // from loginMixin
        ...mapGetters('account', [
            'account_info'
        ]),
        permission () {
            return {
                //resource
                RESOURCE_DASHBOARD_ISSUE_REPORT ,
                RESOURCE_DETAIL ,
                RESOURCE_DIGITAL_RESOURCE_MANAGEMENT ,
                RESOURCE_DIGITAL_OBJECT_MANAGEMENT ,
                RESOURCE_FILE_TYPE_MANAGEMENT ,
                RESOURCE_ACCOUNT_MANAGEMENT ,
                RESOURCE_SYSTEM_LOG ,
                RESOURCE_ISSUE_REPORT_MANAGEMENT ,
                RESOURCE_MY_ISSUE_REPORT ,
                RESOURCE_SYNONYM_MANAGEMENT ,
                RESOURCE_REVIEW ,
                RESOURCE_FRONT_STAGE_DATA ,
                //role
                ROLE_SYSTEM_SUPER_ADMIN ,
                ROLE_SYSTEM_ADMIN ,
                ROLE_ORDINARY_USER ,
                ROLE_DATA_INPUT ,
                //action
                GET ,
                LIST ,
                ADD ,
                EDIT ,
                DELETE ,
                REVIEW ,
                EXPORT ,
                IMPORT ,
                SUSPEND,
                RESUME, 
                CHANGE_PASSWORD,
                //reject
                REJECT_REDIRECT,
                //utils
                utils: {
                    compare_role
                }
            }
        },
        page_name () {
            return {
                ...PageName
            }
        },
    },
    methods: {
        permission_check ({resource_info, access, reject}) {
            console.log('permission: check: resource_info=', resource_info, ', access=', access)
            console.log('permission: check: account_info=', this.account_info)
            //policy(user_info, resource_info, access)

            let check_result = false
            if (this.account_info && this.account_info['roles']) {
                let role = this.account_info['roles'][0]

                let policy = POLICY[role['role_name']][resource_info['name']]

                let sub_res = false
                if (typeof policy === 'boolean') {
                    sub_res = policy
                }
                else if (typeof policy === 'function') {
                    sub_res = policy({account_info: this.account_info, resource_info, access})
                }
                else {
                    console.log('[ERR] permission: not supported policy type:', typeof policy)
                }
                
                if (sub_res === true) {
                    check_result = true
                }
            }

            if (!check_result && typeof reject !== 'undefined' ) {
                if (typeof reject === 'object') {
                    if (reject['action'] === REJECT_REDIRECT && typeof reject['path'] !== 'undefined') {
                        Message.warning({message: '權限不足'})
                        this.backstage_router_push({ path: reject['path'] })
                        console.log('permission: check: redirect to :', reject['path'])
                        return
                    }
                }
            }
            return check_result

            // created_time: Object
            // email: "test@demo.com"
            // id: 1
            // org_name: null
            // password: "12345"
            // roles: Array(1)
            //     0: "系統管理者"
            //     length: 1
            //     __ob__: Observer {value: Array(1), dep: Dep, vmCount: 0}
            //     __proto__: Array
            // session_id: "2cfdj00hpci2d0tqis841bk1b6"
            // status: "開通"
            // updated_time: Object
            // username: "王柏泓"
        },
        is_current_user_admin () {
            if (this.account_info && this.account_info['roles']) {
                let role = this.account_info['roles'][0]

                if ([ROLE_SYSTEM_SUPER_ADMIN, ROLE_SYSTEM_ADMIN].indexOf(role['role_name']) !== -1) {
                    return true
                }
            }
            return false
        }
    }
}